import { all, call, put, takeEvery } from 'redux-saga/effects';

import {
  getContentfulEntries as getContentfulEntriesApi,
} from '../services/contentfulApi';
import {
  contentfulEntriesFailed,
  contentfulEntriesLoaded,
  getContentfulEntries as GET_CONTENTFUL_ENTRIES,
} from '../actions';

export function* getContentfulEntries({ payload: {
  contentType,
  key,
  query,
} }) {
  const response = yield call(getContentfulEntriesApi, { contentType, query });

  if (response.ok) {
    yield put(contentfulEntriesLoaded({ data: response.data, key }));
  } else {
    yield put(contentfulEntriesFailed({ error: response.devError, key }));
  }
}

export function* contentfulSaga() {
  yield all([
    takeEvery(GET_CONTENTFUL_ENTRIES, getContentfulEntries),
  ]);
}
